import React from 'react';
export default class AppDrawerSubMenu extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "drawer-submenu",
      "data-drawer-submenu": true
    }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
      className: "submenu-back",
      "data-submenu-back-button": true
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons pointer"
    }, "first_page"), /*#__PURE__*/React.createElement("span", null, "BACK")), /*#__PURE__*/React.createElement("div", {
      className: "submenu-close",
      "data-submenu-close-button": true
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "close"))), /*#__PURE__*/React.createElement("nav", {
      className: "submenu-nav"
    }));
  }
}